import PropTypes from 'prop-types';
import React from 'react';

class CheckboxField extends React.Component {
  render() {
    const { input, disabled } = this.props;
    return (
      <div
        className="checkbox checkbox-primary"
        style={{ marginTop: '0px', marginBottom: '0px' }}
      >
        <input {...input} type="checkbox" disabled={disabled} />
        <label />
      </div>
    );
  }
}

CheckboxField.propTypes = {
  disabled: PropTypes.boolean,
};

CheckboxField.defaultProps = {
  disabled: false,
};

export default CheckboxField;
